module.exports = __webpack_public_path__ + "img/companyIconWeavr.53175ceb.svg";